export class RequestTimeout extends Error {
  constructor() { super('The connection is taking too long. Please try again.'); this.name = 'RequestTimeout'; }
}
// Includes authentication and reading the response body, not just receiving headers.
// The race also bounds callers whose underlying transport ignores cancellation.
export async function withDeadline<T>(work: (signal: AbortSignal) => Promise<T>, milliseconds = 20000): Promise<T> {
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout>;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => { reject(new RequestTimeout()); controller.abort(); }, milliseconds);
  });
  try { return await Promise.race([work(controller.signal), timeout]); }
  finally { clearTimeout(timer!); }
}
